import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from '../../../models/utilities/filter-bar';
import { ListColumn, SelectedSort } from '../../../models/utilities/list-header';
import { PageData } from '../../../models/utilities/paged-request';
import { ApiEndpoints, GlobalConstants } from '../../../utils/app-constants';
import { AppUtils } from '../../../utils/app-utils';
import { AssetStatusMetadata, AssetTypeMetadata } from '../enums/_index';

export class AssetSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.TRANSPORTATION_FLEET_ASSETS_SEARCH;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('ID', 'id', true),
            new ListColumn('Name', 'name', true),
            new ListColumn('Type', ''),
            new ListColumn('Service Center', ''),
            new ListColumn('Status', '')
        ];

        // Create our Filter Groups
        const byName        = this.buildAssetName();
        const byStatus      = this.buildStatus();
        const byType        = this.buildType();
        
        this.filters.push(
            byStatus, byName, byType
        );

    }

    // #region Group Builders

    private buildStatus() {        
        const byStatus = new FilterGroup('Status', 'checkboxes', 'status');
        byStatus.opts = AppUtils.enumMetadataToFilters(AssetStatusMetadata);

        byStatus.opts.forEach((itm : FilterBarInputOpt) => {
            itm.data = (itm.qsValue === 0) ? true : false;
        });

        return byStatus;
    }

    private buildType() {        
        const byType = new FilterGroup('Type', 'checkboxes', 'type');
        byType.opts = AppUtils.enumMetadataToFilters(AssetTypeMetadata);

        byType.opts.forEach((itm : FilterBarInputOpt) => {
            itm.data = true;
        });

        return byType;
    }

    private buildAssetName() {
        const byAssetName = new FilterGroup('Name', 'text', 'name');
        const opt1 = new FilterBarInputOpt('Name', '');
        
        byAssetName.opts = [opt1];

        return byAssetName;
    }
    
    // #endregion

}
